<div>
  <app-knowledge-list-page [activateDocxImport]="true"></app-knowledge-list-page>
</div>
